import { styled } from 'styled-components';

export const PricingSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 96px 0;
  align-items: center;
  background-color: ${(props) => props.theme.colors.default[50]};
`;

export const PricingSectionHeader = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
`;

export const PricingSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
`;

export const PricingCardWrapper = styled.div`
  width: 100%;
  overflow: auto;
  scrollbar-width: none;
`;

export const PricingCardContainer = styled.div`
  display: flex;
  width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 12px;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    max-width: 100%;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px;
  color: ${({ theme }) => theme.colors.default[500]};
`;
